import type { SVGProps } from 'react'

const Timelock = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 6.5V6C7 4.34315 8.34315 3 10 3V3C11.6569 3 13 4.34315 13 6V6.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.5V11.375"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9375 12.3125L10 11.375"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 11.375C4.375 8.2684 6.8934 5.75 10 5.75V5.75C13.1066 5.75 15.625 8.2684 15.625 11.375V11.375C15.625 14.4816 13.1066 17 10 17V17C6.8934 17 4.375 14.4816 4.375 11.375V11.375Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Timelock
